import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresseTEMPOST } from '../../../../../models/eforms/dila/TypeAdresseTEMPOST';
import { CTRL_TRIM } from '../../../../formulaires/validators/TRIM/ctrlTRIM';
import { CTRL_1222 } from '../../../../formulaires/validators/1222/ctrl1222';
import { FacturationMessage } from '../../../../shared/models/component-messages/facturation/facturation';
import { CTRL_1216 } from '../../../../formulaires/validators/1216/ctrl1216';
import { CTRL_268 } from '../../../../formulaires/validators/268/ctrl268';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { StepperBuilderService } from '../../services/stepper.builder.service';
import { TypeEntiteResponse } from '../../../../../models/typeEntiteResponse';
import { TypeEntite, TypeEntiteChangeEvent } from '../../../../../models/typeEntite';
import { FacturationService } from '../../../../formulaires/common/services/facturation/facturation.service';
import {SpinnerVisibilityService} from 'ng-http-loader';
import { IdentifiantAdressage } from '../../../../../models/identifiantAdressage';
import { IdentifiantAdressageData } from '../../../../../models/identifiantAdressageData';
import { Subject } from 'rxjs';
import {finalize, pairwise, startWith, take, takeUntil} from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../../shared/modals/information/information.component';

@Component({
  selector: 'app-type-adresseTEMPOST',
  templateUrl: './type-adresseTEMPOST.component.html',
  styleUrls: ['./type-adresseTEMPOST.component.scss'],
})
export class TypeAdresseTEMPOSTComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() uid = '';

  public current_uid = 'TypeAdresseTEMPOST';
  @Input() parentForm: FormGroup;
  @Input() libelle: TypeAdresseTEMPOST;
  @Input() disabled: boolean;
  @Input() typeEntite: TypeEntite;
  @Output() typeEntiteChange = new EventEmitter<TypeEntiteChangeEvent>();
  @Input() noServiceExecutant: string;
  @Input() numBonCommande: string;
  @Input() identifiantAdressage: string;

  public siretCtrName: string;
  public rg1 = CTRL_1222.id + '_1';
  public rg2 = 'CTRL_FACTURATION';
  public rg3 = CTRL_TRIM.id + '_1';
  public rg4 = CTRL_1216.id + '_1';
  public rg5 = CTRL_268.id + '_9';

  public optionsSelect: any[];
  public optionsSelectType = 'PAYS';
  public facturationMessage = new FacturationMessage();
  public typeEntiteVerificationErrorCtrlName = '';
  public numBonCommandeCtrlName = '';
  public noServiceExecutantCtrlName = '';
  public identifiantAdressageCtrlName = '';
  public typeEntiteCtrlName = '';
  public identifiantsAdressageOptions: IdentifiantAdressage[] = [];
  // REQ3936109 : quand G2B ne fournit aucune donnée exploitable (erreur technique,
  // SIREN absent, ou type d'entité non exploitable), l'utilisateur reprend la main : le radio Type
  // d'entité se dégrise et l'identifiant d'adressage devient un champ de saisie libre.
  public saisieManuelleFacturation = false;
  // REQ3936109 : les données G2B prévalent toujours sur la préférence appliquée ; ce drapeau ne
  // fait qu'informer l'utilisateur d'une divergence, sans jamais influencer la valeur retenue.
  public divergenceTypeEntitePreference = false;
  // REQ3936109 : l'identifiant d'adressage d'une préférence appliquée peut ne plus figurer
  // dans la liste G2B de l'établissement (établissement changé, identifiant retiré...).
  public identifiantAdressagePreferenceAbsente = false;
  private readonly siretEtat = '11000201100044';
  private readonly unsubscribe$ = new Subject<void>();
  // Compteur d'appel pour loadIdentifiantsAdressage() : dans le flux Préférences, TypeFacturationComponent
  // appelle cette méthode directement ET indirectement (via verifierSiret(true) -> onTypeEntiteVerifie()),
  // deux requêtes HTTP concurrentes qui réassignent chacune identifiantsAdressageOptions avec un nouveau
  // tableau -> double churn du *ngFor d'options, qui a fait perdre la sélection déjà posée par la
  // préférence sur le <select> natif. Ignorer la réponse d'un appel devenu obsolète règle ce cas.
  private loadIdentifiantsAdressageCallId = 0;

  constructor(private autoCompleteService: AutoCompleteService,
              private canNavigateInStepperService: CanNavigateInStepperService,
              private facturationService: FacturationService,
              private stepperBuilderService: StepperBuilderService,
              private spinner: SpinnerVisibilityService,
              private cd: ChangeDetectorRef,
              private modalService: NgbModal) {}

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_1222Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_facturationNames_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_TrimNames_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_1222Names_json() }));
    this.siretCtrName = this.getUid() + '_SepAtt_siret';
    this.typeEntiteVerificationErrorCtrlName = this.getUid() + '_SepAtt_CTRL_TYPE_ENTITE_VERIFICATION';
    this.numBonCommandeCtrlName = this.uid + '_SepAtt_numBonCommande';
    this.noServiceExecutantCtrlName = this.uid + '_SepAtt_noServiceExecutant';
    this.identifiantAdressageCtrlName = this.uid + '_SepAtt_identifiantAdressage';
    // Contrôle nommé CTRL_* pour être lu par le mécanisme RG générique de isFormValid()
    // (formulaire-service.service.ts), comme CTRL_TRIM/CTRL_1222 dans ce même composant.
    // Erreur "obligatoire" par défaut tant qu'aucune vérification SIRET n'a abouti ; si l'avis
    // relu porte déjà un type d'entité connu, il n'y a rien à re-vérifier.
    const typeEntiteDejaVerifie = this.typeEntite === 'Publique' || this.typeEntite === 'PriveeAssujettie';
    this.parentForm.addControl(this.typeEntiteVerificationErrorCtrlName, new FormControl(
      typeEntiteDejaVerifie
        ? { ctrlValidation: false }
        : { ctrlValidation: true, validation_message: 'error.ctr_type_entite_obligatoire' }
    ));
    this.typeEntiteCtrlName = this.uid + '_SepAtt_typeEntite';

    if (!this.libelle) {
      this.libelle = new TypeAdresseTEMPOST();
    }
    if (!this.libelle.pays) {
      this.libelle.pays = '';
    }

    // Au chargement d'un avis existant, le select Identifiant d'adressage n'a d'options
    // que si l'utilisateur reclique sur "Récupérer les données" (loadIdentifiantsAdressage n'est appelée
    // que depuis onTypeEntiteVerifie). Si le SIRET et le type d'entité PriveeAssujettie sont
    // déjà connus (avis relu depuis le back), il faut précharger la liste pour que la valeur
    // sauvegardée puisse s'afficher dans le select.
    if (this.typeEntite === 'PriveeAssujettie' && this.libelle?.siret) {
      this.loadIdentifiantsAdressage(this.libelle.siret);
    }
  }

  public ngAfterViewInit(): void {
    const siretControl = this.parentForm.get(this.siretCtrName);
    // startWith+pairwise (plutôt que distinctUntilChanged, qui ne compare que des émissions déjà
    // passées par le flux) : TypeFacturationComponent.applySiretState() rejoue un setValue() avec
    // la MÊME valeur au chargement d'un avis "SIRET état" existant (cas édition) — comme il s'agit
    // là de la toute première émission depuis l'abonnement, distinctUntilChanged l'aurait laissée
    // passer et aurait invalidé à tort un typeEntite pourtant déjà correct.
    siretControl?.valueChanges
      .pipe(
        startWith(siretControl.value),
        pairwise(),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(([previousSiret, currentSiret]) => {
        if (previousSiret !== currentSiret) {
          this.onSiretChanged();
        }
      });

    // Le FormControl du radio est créé par app-form-input lui-même (rule="required") : il n'existe
    // pas encore dans ngOnInit. En mode saisie manuelle, ce contrôle est réactivé (enable()) et c'est
    // alors le seul moyen de savoir que l'utilisateur a choisi une valeur (checkRadioButton ne fait
    // que setValue() sur le contrôle, sans notifier le parent autrement que par valueChanges).
    const typeEntiteControl = this.parentForm.get(this.typeEntiteCtrlName);
    typeEntiteControl?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: TypeEntite) => {
        if (!this.saisieManuelleFacturation) {
          // Les écritures programmatiques (onTypeEntiteVerifie, onTypeEntiteVerificationEchec) posent
          // toujours saisieManuelleFacturation à false avant leur setValue() : elles sont donc ignorées
          // ici. Seule exception, activerSaisieManuelleFacturation() : son setValue(undefined) interne
          // s'exécute AVANT que le flag ne passe à true (voir son code), donc il est ignoré lui aussi -
          // seule une vraie interaction utilisateur ultérieure (flag déjà true) est traitée.
          return;
        }
        // Référence de comparaison : this.typeEntite et non le FormControl, qui porte déjà la
        // nouvelle valeur quand valueChanges notifie. Pas de setValue() non plus, le réécrire depuis
        // son propre abonnement rebouclerait.
        const hasChanged = value !== this.typeEntite;
        this.typeEntite = value;
        this.identifiantsAdressageOptions = [];
        this.appliquerBasculeTypeEntite(value, false, hasChanged);
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private onSiretChanged(): void {
    // Sans cette invalidation, une vérification SIRET réussie plus tôt reste valide même si le
    // SIRET change ensuite (saisie manuelle ou écriture programmatique par applySiretState()).
    // Un changement de SIRET invalide aussi tout mode saisie manuelle en cours : il portait sur
    // l'ancien SIRET, l'utilisateur doit re-cliquer sur « Récupérer les données ».
    this.onTypeEntiteVerificationEchec();
    this.parentForm.get(this.typeEntiteVerificationErrorCtrlName)?.setValue(
      { ctrlValidation: true, validation_message: 'error.ctr_type_entite_obligatoire' }
    );
  }

  getCtrl_1222Names_json(): any {
    return {
      etat: '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region',
      siret: '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret'
    };
  }

  getCtrl_facturationNames_json(): any {
    return {
      etat: '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region',
      siret: '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret'
    };
  }

  getCtrl_TrimNames_json(): any {
    return { text: '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr3' };
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return '_STEP_ID_SepSep_TypeFacturation';
  }

  isNotEform() {
    if (this.canNavigateInStepperService.currentFormulaire && this.canNavigateInStepperService.currentFormulaire.includes('E_FORM')) {
      return false;
    }

    this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
    return true;
  }

  private getCtrl_268Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  public onTypeEntiteVerifie(response: TypeEntiteResponse, siret: string, fromPreference = false,
                             typeEntitePreference?: TypeEntite): void {
    // Une nouvelle vérification du même SIRET peut aboutir après un premier échec (annuaire à
    // nouveau disponible, SIREN désormais connu...) : sans cette sortie du mode saisie manuelle, le
    // radio resterait dégrisé et l'identifiant d'adressage resterait en saisie libre.
    this.desactiverSaisieManuelleFacturation();
    // Type précédent lu sur le FormControl et non sur this.typeEntite : cette propriété vient de
    // l'@Input, que le parent peut ne repropager qu'après ce retour d'appel, alors que le contrôle
    // porte déjà le type posé par la préférence appliquée ou par la vérification précédente. Se fier
    // à la propriété conclurait donc parfois à tort "pas de changement", sans vider les champs.
    const typeEntitePrecedent: TypeEntite | undefined = this.parentForm.get(this.typeEntiteCtrlName)?.value;
    const hasChanged = response?.typeEntite !== typeEntitePrecedent;
    this.typeEntite = response?.typeEntite;
    // Pas de emitEvent:false ici : app-form-input (ngAfterViewInit) synchronise sa propre variable
    // d'affichage currentCheckedValue via un abonnement à valueChanges de ce même FormControl - avec
    // emitEvent:false, le FormControl a la bonne valeur mais le radio reste visuellement vide
    // (régression constatée). saisieManuelleFacturation est déjà à false à ce stade (ligne
    // précédente), donc l'abonnement de CE composant à valueChanges (ngAfterViewInit) ignore
    // cette écriture sans avoir besoin de emitEvent:false.
    this.parentForm.get(this.typeEntiteCtrlName)?.setValue(this.typeEntite);
    this.appliquerBasculeTypeEntite(this.typeEntite, fromPreference, hasChanged);
    this.parentForm.get(this.typeEntiteVerificationErrorCtrlName)?.setValue({ ctrlValidation: false });
    // typeEntiteVerificationErrorCtrlName est lu par isFormValid() (nom CTRL_-préfixé) : sans ce
    // retrait explicite, le bandeau d'erreurs de l'étape garderait l'ancienne erreur "obligatoire"
    // affichée jusqu'au prochain scan complet (clic Suivant/Enregistrer).
    this.stepperBuilderService.removeFieldFromStepErrors(this.getStepId(), this.typeEntiteVerificationErrorCtrlName);
    // REQ3936109 : les données G2B prévalent (déjà le cas ci-dessus, this.typeEntite = response),
    // ce drapeau informe seulement l'utilisateur si elles divergent de sa préférence.
    this.divergenceTypeEntitePreference = fromPreference && !!typeEntitePreference && typeEntitePreference !== this.typeEntite;

    if (this.typeEntite === 'PriveeAssujettie') {
      this.loadIdentifiantsAdressage(siret, fromPreference);
    } else {
      this.identifiantsAdressageOptions = [];
    }
  }

  /**
   * Vide les champs dont la nature dépend du type d'entité dès que celui-ci bascule vers un autre
   * type connu, y compris depuis une préférence, puis notifie le parent pour qu'il nettoie de son
   * côté le modèle "facturation".
   */
  private appliquerBasculeTypeEntite(nouveauTypeEntite: TypeEntite | undefined, fromPreference: boolean,
                                     hasChanged: boolean): void {
    // Vidage des FormControls et non des seuls @Input : ce sont eux que lisent les extracteurs, et
    // le *ngIf ne démonte pas toujours le champ - de "type inconnu" vers "Publique", le n° de
    // service exécutant reste monté avec son ancienne valeur.
    if (hasChanged) {
      this.parentForm.get(this.numBonCommandeCtrlName)?.reset();
      this.parentForm.get(this.noServiceExecutantCtrlName)?.reset();
      // En "PriveeAssujettie", ce reset est immédiatement suivi du setValue(currentValue || '')
      // de loadIdentifiantsAdressage() : la valeur repart à '', l'option vide du <select>.
      this.parentForm.get(this.identifiantAdressageCtrlName)?.reset();
    }

    this.typeEntiteChange.emit({ typeEntite: nouveauTypeEntite, fromPreference, hasChanged });
  }

  /**
   * REQ3936109 (nouvelle RG) : le SIRET de l'État impose "Entité publique" même quand ses données de
   * facturation électronique n'ont pas pu être récupérées auprès de G2B — contrairement à tout autre
   * SIRET, la saisie manuelle libre n'est pas proposée dans ce cas précis (RG spécifique déjà
   * existante pour ce SIRET, cf. le contrôle "typeEntite_publiqueObligatoirePourSiretEtat").
   */
  private forcerTypeEntitePublique(fromPreference = false, typeEntitePreference?: TypeEntite): void {
    this.onTypeEntiteVerifie({ typeEntite: 'Publique' } as TypeEntiteResponse, this.siretEtat, fromPreference, typeEntitePreference);
  }

  /**
   * Données de facturation électronique non récupérables auprès de G2B (erreur technique, SIREN
   * absent de l'annuaire, ou entreprise connue mais type d'entité non exploitable) : la saisie ne
   * doit plus être bloquée (REQ3936109, nouvelle RG). Le radio Type d'entité se dégrise et
   * l'utilisateur choisit librement sa valeur ; l'identifiant d'adressage devient un champ de saisie
   * libre (cf. type-adresseTEMPOST.component.html).
   *
   * A l'application d'une préférence, le radio est positionné sur le type d'entité de
   * la préférence. Et elle reste modifiable puisque le radio est dégrisé.
   */
  public activerSaisieManuelleFacturation(fromPreference = false, typeEntitePreference?: TypeEntite): void {
    if (this.parentForm.get(this.siretCtrName)?.value === this.siretEtat) {
      // REQ3936109 : même sur le SIRET de l'État (type forcé à "Publique", pas de saisie
      // manuelle proposée), la valeur retenue peut diverger de la préférence appliquée - le paramètre
      // est transmis pour que onTypeEntiteVerifie() puisse détecter et signaler cette divergence.
      this.forcerTypeEntitePublique(fromPreference, typeEntitePreference);
      return;
    }

    // Hors préférence, aucune valeur à proposer
    const typeEntiteRetenu = fromPreference ? typeEntitePreference : undefined;

    this.typeEntite = typeEntiteRetenu;
    // Liste vidée : l'identifiant d'adressage passe en saisie libre. app-form-input change de
    // ngSwitchCase sans être recréé et les deux cas partagent le même formControlName, la valeur
    // déjà saisie est donc conservée.
    this.identifiantsAdressageOptions = [];
    this.divergenceTypeEntitePreference = false;
    this.identifiantAdressagePreferenceAbsente = false;
    if (!this.disabled) {
      // Un avis en lecture seule (ex. avis déjà publié) ne doit pas redevenir éditable même en mode
      // saisie manuelle : this.disabled prévaut toujours sur saisieManuelleFacturation.
      this.parentForm.get(this.typeEntiteCtrlName)?.enable({ emitEvent: false });
    }
    // Pas de emitEvent:false : app-form-input a besoin de cette émission pour synchroniser sa propre
    // variable d'affichage currentCheckedValue (cf. onTypeEntiteVerifie()). saisieManuelleFacturation
    // n'est mis à true qu'après cette ligne : l'abonnement valueChanges de CE composant (ngAfterViewInit)
    // voit encore le flag à false au moment de cette écriture interne et l'ignore donc correctement,
    // sans avoir besoin de emitEvent:false pour la distinguer d'un vrai choix utilisateur.
    this.parentForm.get(this.typeEntiteCtrlName)?.setValue(typeEntiteRetenu);
    this.saisieManuelleFacturation = true;
    // hasChanged: false - le type devient inconnu, ou reprend celui de la préférence qui
    // était déjà le sien. Les champs qui en dépendent gardent donc leur valeur jusqu'au choix de
    // l'utilisateur, traité par l'abonnement au radio.
    this.appliquerBasculeTypeEntite(typeEntiteRetenu, fromPreference, false);
    // Le radio réactivé porte désormais lui-même la règle "required" (validation Angular standard) :
    // le contrôle caché ne doit plus signaler l'obligation, sous peine de doublon.
    this.parentForm.get(this.typeEntiteVerificationErrorCtrlName)?.setValue({ ctrlValidation: false });
    this.stepperBuilderService.removeFieldFromStepErrors(this.getStepId(), this.typeEntiteVerificationErrorCtrlName);
  }

  private desactiverSaisieManuelleFacturation(): void {
    // Ne regriser le contrôle que si on quitte réellement le mode saisie manuelle : un disable()
    // systématique (y compris lors d'une 1re vérification réussie, où il n'y a jamais eu de saisie
    // manuelle à quitter) perturbait à tort l'affichage de la valeur qui suit (régression constatée :
    // le type d'entité ne se cochait plus pour une entreprise privée trouvée dans G2B).
    if (this.saisieManuelleFacturation) {
      this.parentForm.get(this.typeEntiteCtrlName)?.disable({ emitEvent: false });
    }
    this.saisieManuelleFacturation = false;
  }

  public onTypeEntiteVerificationEchec(fromPreference = false): void {
    this.desactiverSaisieManuelleFacturation();
    this.typeEntite = undefined;
    this.identifiantsAdressageOptions = [];
    this.divergenceTypeEntitePreference = false;
    this.identifiantAdressagePreferenceAbsente = false;
    // Pas de emitEvent:false ici, même raison que dans onTypeEntiteVerifie().
    this.parentForm.get(this.typeEntiteCtrlName)?.setValue(this.typeEntite);
    // hasChanged: false - même raison que dans activerSaisieManuelleFacturation() : le type devient
    // seulement inconnu (changement de SIRET, format refusé...), les valeurs saisies sont gardées.
    this.appliquerBasculeTypeEntite(this.typeEntite, fromPreference, false);
  }

  public ouvrirInfobulleSiret(): void {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.content = this.facturationMessage.InfobulleSiret;
  }

  public verifierSiret(fromPreference = false, typeEntitePreference?: TypeEntite): void {
    const siretControl = this.parentForm.get(this.siretCtrName);

    // Dans le cas d'une saisie déjà invalide (pattern_20 -> ctr_1216, ou required -> ctr_1210),
    // le message est affiché sous le champ.
    // Il est donc inutile d'appeler l'API et de le répéter sur le contrôle de vérification.
    // Le contrôle de format côté back a tout de même été mis en place par sécurité
    if (siretControl?.invalid) {
      return;
    }

    const siret = siretControl?.value;

    this.spinner.show();
    // isFormValid() lit directement value.ctrlValidation sans garde sur null : ne jamais remettre
    // ce contrôle à null, toujours une forme { ctrlValidation, ... }.
    let reponseRecue = false;

    this.facturationService.getTypeEntite(siret)
      .pipe(take(1), finalize(() => this.spinner.hide()))
      .subscribe({
      next: (response: TypeEntiteResponse) => {
        reponseRecue = true;
        // Réponse présente mais sans statut HTTP : le back a refusé le format du SIRET sans appeler
        // l'annuaire G2B (AnnuaireG2BServiceImpl.formatSIRETIncorrect) et renvoie un objet vide. C'est
        // une saisie invalide, pas un bug : on affiche le même message que le contrôle de format du
        // champ (pattern_20 -> ctr_1216)
        const statutHttpAbsent = !!response && (response.httpStatusCode === null || response.httpStatusCode === undefined);
        if (statutHttpAbsent) {
          this.onTypeEntiteVerificationEchec(fromPreference);
          this.parentForm.get(this.typeEntiteVerificationErrorCtrlName)?.setValue({ ctrlValidation: true, validation_message: 'error.ctr_1216' });
          return;
        }

        // Tout statut hors 2xx : annuaire G2B ou jeton PISTE injoignable (503), ou code erreur renvoyé par G2B.
        // Le 204 correspond à "aucun résultat" et non à une erreur.
        if (!this.isSuccess(response?.httpStatusCode) && response?.httpStatusCode !== 204) {
          this.activerSaisieManuelleFacturation(fromPreference, typeEntitePreference);
          return;
        }

        if (!response?.typeEntite) {
          // SIREN absent de l'annuaire (entrepriseTrouvee=false), ou entreprise connue mais type
          // d'entité non exploitable (champ absent, valeur hors "Publique"/"Privée assujettie", ou
          // plusieurs résultats) : dans les deux cas, la saisie manuelle est désormais autorisée
          // (REQ3936109, nouvelle RG) plutôt que de retenir une valeur par défaut ou de bloquer.
          this.activerSaisieManuelleFacturation(fromPreference, typeEntitePreference);
          return;
        }

        if (siret === this.siretEtat && response.typeEntite !== 'Publique') {
          this.onTypeEntiteVerificationEchec(fromPreference);
          this.parentForm.get(this.typeEntiteVerificationErrorCtrlName)?.setValue({ ctrlValidation: true, validation_message: 'error.typeEntite_publiqueObligatoirePourSiretEtat' });
          return;
        }

        this.onTypeEntiteVerifie(response, siret, fromPreference, typeEntitePreference);
      },
      error: () => {
        this.activerSaisieManuelleFacturation(fromPreference, typeEntitePreference);
      },
      // HttpService.process() intercepte les erreurs HTTP avec un catchError qui log, affiche
      // l'erreur générique et renvoie EMPTY : l'observable complète alors sans avoir émis, donc ni next()
      // ni error() ne s'exécutent.
      // Sans ce complete(), aucun message n'apparaîtrait sous le champ
      complete: () => {
        if (!reponseRecue) {
          this.activerSaisieManuelleFacturation(fromPreference, typeEntitePreference);
        }
      }
    });
  }

  public loadIdentifiantsAdressage(siret: string, fromPreference = false): void {
    const callId = ++this.loadIdentifiantsAdressageCallId;
    this.facturationService.getIdentifiantsAdressage(siret)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((items) => {
        if (callId !== this.loadIdentifiantsAdressageCallId) {
          // Une requête plus récente a été lancée entre-temps (cf. commentaire sur loadIdentifiantsAdressageCallId) :
          // sa réponse prévaudra, ignorer celle-ci pour ne pas réécraser inutilement les options/la valeur.
          return;
        }
        // Option vide en tête de liste (code '', assortie à [value]="identifiantAdressage || ''") :
        // sans elle, un <select> natif sans correspondance affiche silencieusement le 1er identifiant
        // réel dès que la liste se peuple, alors que le FormControl n'a jamais été positionné par
        // l'utilisateur — le champ est alors soumis comme rempli avec une valeur qu'il n'a pas choisie.
        this.identifiantsAdressageOptions = [
          { code: '', libelle: this.facturationMessage.IdentifiantAdressageChoisir, avecPlateforme: false },
          ...this.sortIdentifiantsAdressage(items)
        ];
        this.cd.detectChanges();
        setTimeout(() => {
          const identifiantAdressageControl = this.parentForm.get(this.identifiantAdressageCtrlName);
          const currentValue = identifiantAdressageControl?.value;
          // REQ3936109 : la préférence appliquée peut porter un identifiant qui ne figure plus
          // dans la liste G2B de l'établissement (établissement changé, identifiant retiré...). Un
          // <select> natif sans correspondance n'affiche déjà rien de sélectionné, mais le FormControl
          // resterait rempli avec une valeur invalide sans que l'utilisateur en soit averti.
          if (fromPreference && currentValue
            && !this.identifiantsAdressageOptions.some(option => option.code === currentValue)) {
            this.identifiantAdressagePreferenceAbsente = true;
            identifiantAdressageControl?.setValue('');
            identifiantAdressageControl?.valueChanges
              .pipe(take(1), takeUntil(this.unsubscribe$))
              .subscribe(() => this.identifiantAdressagePreferenceAbsente = false);
            return;
          }
          this.identifiantAdressagePreferenceAbsente = false;
          identifiantAdressageControl?.setValue(currentValue || '');
        });
      });
  }

  private sortIdentifiantsAdressage(items: IdentifiantAdressageData[]): IdentifiantAdressage[] {
    return items
      .map((item) => ({
        code: item.identifiantAdressage,
        libelle: item.identifiantAdressage,
        avecPlateforme: item.statutPlateforme === 'Plateforme active'
      }))
      .sort((a, b) => {
        if (a.avecPlateforme !== b.avecPlateforme) {
          return a.avecPlateforme ? -1 : 1;
        }
        return a.libelle.localeCompare(b.libelle, 'fr', { numeric: true, sensitivity: 'base' });
      });
  }

  private isSuccess(httpStatusCode: number): boolean {
    return httpStatusCode >= 200 && httpStatusCode < 300;
  }

}
